module.exports = __webpack_public_path__ + "static/media/skull-crossbones.39d47c3f.svg";